import React from 'react';
import PropTypes from 'prop-types';

const Note = ({value}) => (
  <p className="text-grey-darkest text-12 my-2">{value}</p>
);

Note.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default Note;
